import * as helper from './../../../../../VX/View/Assets/Js/helper';
import AlertBox from './AlertBox';
import SignupBackend from '../../../Assets/Js/SignupBackend';

export default class Section7 {
	constructor() {
		const $section7 = helper.$('#section7');
		this.username = helper.$('#username');
		this.email = helper.$('#email');
		this.agb = helper.$('#inputagb');

		this.Form = helper.$('#emailform');
		this.Signup = new SignupBackend(helper.getData(this.Form, 'w'), helper.getData(this.Form, 'ws'));

		this.alertBox = new AlertBox($section7);
	}

	get values() {
		return {
			'email' : this.email.value
		};
	}

	isValid() {
		if (!this.username.value.match(/^[a-z0-9-]{6,}$/i)) {
			helper.addClass(this.username, 'alertborder');
			this.alertBox.show('Dieser Username ist nicht gültig (min. 6 Zeichen, nur Buchstaben, Zahlen und Bindestrich)');
			return false;
		}
		helper.removeClass(this.username, 'alertborder');

		if (!this.email.value.match(/^.+@.+\..+$/g)) {
			helper.addClass(this.email, 'alertborder');
			this.alertBox.show('Diese E-Mail ist nicht valide');
			return false;
		}
		helper.removeClass(this.email, 'alertborder');

		if (!this.agb.checked) {
			helper.addClass(this.agb, 'alertborder');
			this.alertBox.show('Bitte bestätige unsere AGB und Datenschutzerklärung');
			return false;
		}
		helper.removeClass(this.agb, 'alertborder');

		this.alertBox.hide();

		this.Signup.checkSignup(this.username.value, this.email.value)
			.then((response) => {
				if (typeof response.data.messages.username !== 'undefined' && response.data.messages.username !== '') {
					this.alertBox.show(response.data.messages.username);
					helper.addClass(this.username, 'alertborder');
					return false;
				} else if (typeof response.data.messages.email !== 'undefined' && response.data.messages.email !== '') {
					this.alertBox.show(response.data.messages.email);
					helper.addClass(this.email, 'alertborder');
					return false;
				} else {
					this.Form.submit();
				}
			});

		return true;
	}
}
